import logging from "utils/logging";
import React from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import GameBoardCell from "./GameBoardCell";
import { useSelector } from "react-redux";
import { selectQuestionObjectsForBoard } from "../gameBoardSlice";

const log = logging.getLogger("GameBoard"); //eslint-disable-line no-unused-vars

const RootGrid = styled(Box)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(1.5),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  minHeight: "80vh",
}));

const GridContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  flex: 1,
  height: "100%",
  gap: theme.spacing(0.4),
  position: "relative",
}));

const RowContainer = styled(Box)({
  flex: 1,
  display: "flex",
  width: "100%",
});

const GridRow = ({ cellData }) => {
  if (!cellData || cellData.length === 0) return null;

  const columnCount = cellData.length;

  return (
    <RowContainer>
      <Box
        sx={{
          display: "grid",
          width: "100%",
          height: "100%",
          // Distribute columns evenly so 5 categories don't leave a 1/6 gap
          // (the old MUI Grid md={2} math only handled 4 or 6 cleanly).
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: `repeat(${columnCount}, 1fr)`,
          },
          columnGap: 2,
          rowGap: 0.8,
        }}
      >
        {cellData.map((cell, idx) => (
          <Box key={`grid-row-${cell.label}-${idx}`} sx={{ height: "100%", minWidth: 0 }}>
            <GameBoardCell
              label={cell.label}
              questionId={cell.id}
              status={cell.status}
            />
          </Box>
        ))}
      </Box>
    </RowContainer>
  );
};

const GameBoard = () => {
  const cells = useSelector(selectQuestionObjectsForBoard);

  if (!cells) return null;

  return (
    <RootGrid>
      <GridContainer>
        <GridRow cellData={cells.categories} />
        <GridRow cellData={cells[1]} />
        <GridRow cellData={cells[2]} />
        <GridRow cellData={cells[3]} />
        <GridRow cellData={cells[4]} />
        <GridRow cellData={cells[5]} />
      </GridContainer>
    </RootGrid>
  );
};

export default GameBoard;
